export const orphanModule = 'orphan'
